
// import React from 'react';
// import axios from 'axios';

// export default function NotificationsList({ notifications, setNotifications }) {
//   // Base URL for your API
//   const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001';

//   // Toggle between read/unread status
//   const toggleReadStatus = async (notif) => {
//     console.log(`🔘 Clicked notification ${notif.id}, isRead before toggle:`, notif.isRead);
//     try {
//       if (notif.isRead) {
//         console.log(`→ Sending UNREAD for ${notif.id}`);
//         const res = await axios.post(
//           `${apiUrl}/api/notifications/${notif.id}/unread`,
//           {},
//           { withCredentials: true }
//         );
//         console.log(`← /unread succeeded for ${notif.id}:`, res.data);
//         setNotifications((prev) =>
//           prev.map((n) =>
//             n.id === notif.id
//               ? { ...n, isRead: false }
//               : n
//           )
//         );
//       } else {
//         console.log(`→ Sending READ for ${notif.id}`);
//         const res = await axios.post(
//           `${apiUrl}/api/notifications/${notif.id}/read`,
//           {},
//           { withCredentials: true }
//         );
//         console.log(`← /read succeeded for ${notif.id}:`, res.data);
//         setNotifications((prev) =>
//           prev.map((n) =>
//             n.id === notif.id
//               ? { ...n, isRead: true }
//               : n
//           )
//         );
//       }
//     } catch (err) {
//       console.error(`❌ Error toggling read status for ${notif.id}:`, err);
//     }
//   };

//   // If there are no notifications (or not an array), show a placeholder
//   if (!Array.isArray(notifications) || notifications.length === 0) {
//     return (
//       <div className="p-4 text-gray-600 text-sm text-center">
//         No notifications
//       </div>
//     );
//   }

//   return (
//     <ul className="space-y-2">
//       {notifications.map((notif) => {
//         const { id, type, payload, createdAt, isRead } = notif;
//         const message = payload.message || 'You have a new notification';

//         // Example of “additional info” based on type
//         let additionalInfo = null;
//         if (type === 'courseAssigned' && Array.isArray(payload.courses)) {
//           const titles = payload.courses.map((c) => c.title).join(', ');
//           additionalInfo = (
//             <div className="text-sm text-gray-600">
//               Assigned Courses: {titles}
//             </div>
//           );
//         } else if (type === 'studentReportSubmitted') {
//           additionalInfo = (
//             <div className="text-sm text-gray-600">
//               Course: {payload.courseName} | Student: {payload.studentName}
//             </div>
//           );
//         }

//         return (
//           <li
//             key={id}
//             onClick={() => toggleReadStatus(notif)}
//             className={
//               `cursor-pointer p-3 rounded border ` +
//               (isRead
//                 ? 'bg-gray-50 border-gray-200 hover:opacity-90'
//                 : 'bg-blue-50 border-blue-200 hover:opacity-90')
//             }
//           >
//             {/* 1) Main message */}
//             <div className={isRead ? 'text-gray-800' : 'text-gray-900 font-semibold'}>
//               {message}
//             </div>

//             {/* 2) Additional info if any */}
//             {additionalInfo}

//             {/* 3) Date */}
//             <div className="text-xs text-gray-500 mt-1">{createdAt}</div>
//           </li>
//         );
//       })}
//     </ul>
//   );
// }
// src/Components/NotificationsList.js

import React from 'react';
import axios from 'axios';

export default function NotificationsList({ notifications, setNotifications }) {
  // Base URL for your API
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001';

  // Toggle between read/unread status
  const toggleReadStatus = async (notif) => {
    console.log(`🔘 Clicked notification ${notif.id}, isRead before toggle:`, notif.isRead);
    try {
      if (notif.isRead) {
        console.log(`→ Sending UNREAD for ${notif.id}`);
        const res = await axios.post(
          `${apiUrl}/api/notifications/${notif.id}/unread`,
          {},
          { withCredentials: true }
        );
        console.log(`← /unread succeeded for ${notif.id}:`, res.data);
        setNotifications((prev) =>
          prev.map((n) =>
            n.id === notif.id
              ? { ...n, isRead: false }
              : n
          )
        );
      } else {
        console.log(`→ Sending READ for ${notif.id}`);
        const res = await axios.post(
          `${apiUrl}/api/notifications/${notif.id}/read`,
          {},
          { withCredentials: true }
        );
        console.log(`← /read succeeded for ${notif.id}:`, res.data);
        setNotifications((prev) =>
          prev.map((n) =>
            n.id === notif.id
              ? { ...n, isRead: true }
              : n
          )
        );
      }
    } catch (err) {
      console.error(`❌ Error toggling read status for ${notif.id}:`, err);
    }
  };

  // If there are no notifications (or not an array), show a placeholder
  if (!Array.isArray(notifications) || notifications.length === 0) {
    return (
      <div className="p-4 text-gray-600 text-sm text-center">
        No notifications
      </div>
    );
  }

  return (
    <ul className="space-y-2">
      {notifications.map((notif) => {
        const { id, type, payload, createdAt, isRead } = notif;
        const message = payload.message || 'You have a new notification';

        // “Additional info” for different notification types
        let additionalInfo = null;

        if (type === 'courseAssigned') {
          // Show both assigned course titles AND the teacher’s name
          const titles = Array.isArray(payload.courses)
            ? payload.courses.map((c) => c.title).join(', ')
            : '';

          additionalInfo = (
            <>
              {titles && (
                <div className="text-sm text-gray-600">
                  Assigned Courses: {titles}
                </div>
              )}
              {payload.teacherUsername && (
                <div className="text-sm text-gray-600">
                  Teacher: <span className="font-medium">{payload.teacherUsername}</span>
                </div>
              )}
            </>
          );
        } 
        else if (type === 'studentReportSubmitted') {
          // Existing student report info
          additionalInfo = (
            <div className="text-sm text-gray-600">
              Course: {payload.courseName} | Student: {payload.studentName}
            </div>
          );
        }

        return (
          <li
            key={id}
            onClick={() => toggleReadStatus(notif)}
            className={
              `cursor-pointer p-3 rounded border ` +
              (isRead
                ? 'bg-gray-50 border-gray-200 hover:opacity-90'
                : 'bg-blue-50 border-blue-200 hover:opacity-90')
            }
          >
            {/* 1) Main message */}
            <div className={isRead ? 'text-gray-800' : 'text-gray-900 font-semibold'}>
              {message}
            </div>

            {/* 2) Additional info if any */}
            {additionalInfo}

            {/* 3) Date */}
            <div className="text-xs text-gray-500 mt-1">{createdAt}</div>
          </li>
        );
      })}
    </ul>
  );
}
